export default __webpack_public_path__ + "static/media/data.42f6da15.svg";